<style scoped lang="less">
	@import '../../assets/less/base.less';
	.new-home-page {
		.swiper{
			position: relative;
			height: 798px;
			overflow:hidden;
			@keyframes fadeInRight {
				from {
					opacity: 0;
					transform: translate3d(100%, 0, 0);
				}
				to {
					opacity: 1;
					transform: none;
				}
			}
			
			.fadeInRight {
				animation-name: fadeInRight;
				animation-duration: 1s;
				animation-fill-mode: both;
			}
			
			@keyframes fadeOutLeft {
				from {
					opacity: 1;
				}
				to {
					opacity: 0;
					transform: translate3d(-100%, 0, 0);
				}
			}
			
			.fadeOutLeft {
				animation-name: fadeOutLeft;
				animation-duration: 1s;
				animation-fill-mode: both;
			}
			.new-home-box {
				box-sizing: border-box;
				width: 100%;
				height: 798px;
				margin: 0 auto;
				position: absolute;
				&.img1{
					background: url(../../assets/images/newhomebg.jpg) no-repeat top center;
					background-size: cover;
					padding-top: 204px;
				}
				&.img2{
					background: url(../../assets/images/newhomebg1.jpg) no-repeat top center;
					background-size: cover;
					padding-top: 130px;
				}
				p{
					text-shadow: 0 1px 3px #041c69;
				}
				.title1{
					.banner-title {
						width: 1200px;
						height: 58px;
						margin: 0 auto;
						font-size: 58px;
						color: #FFFFFF;
						line-height: 58px;
						text-indent: 30px;
					}
					.banner-title2 {
						width: 1200px;
						height: 26px;
						margin: 0 auto;
						font-size: 26px;
						color: #FFFFFF;
						line-height: 26px;
						margin-top: 48px;
						text-indent: 30px;
					}
					.banner-title3 {
						width: 1200px;
						height: 26px;
						margin: 0 auto;
						font-size: 26px;
						color: #FFFFFF;
						line-height: 26px;
						margin-top: 16px;
						text-indent: 30px;
					}
				}
				.title2{
					.banner-title {
						width: 1200px;
						height: 26px;
						margin: 0 auto;
						font-size: 26px;
						margin-top: 30px;
						color: #FFFFFF;
						line-height: 26px;
						padding-right: 60px;
						text-align: right;
						letter-spacing:8px;
					}
					.banner-title2 {
						width: 1200px;
						height: 42px;
						margin: 0 auto;
						font-size: 42px;
						color: #FFFFFF;
						line-height: 42px;
						margin-top: 20px;
						text-align: right;
						padding-right: 60px;
						letter-spacing:8px;
					}
					.banner-title3 {
						width: 1200px;
						height: 42px;
						margin: 0 auto;
						font-size: 42px;
						color: #FFFFFF;
						line-height: 42px;
						margin-top: 20px;
						text-align: right;
						padding-right: 60px;
						letter-spacing:8px;
						position: relative;
						&::after{
							content: '';
							display:block;
							width: 80px;
							height: 4px;
							background-color: #fe8f19;
							position: absolute;
							right: 74px;
							top: 50px;
						}
					}
				}
			}
		}

		.new-home-title {
			width: 100%;
			height: auto;
			text-align: center;
			line-height: 18px;
			font-size: 18px;
			color: #333333;
			margin-top: 88px;
		}
		.tellall{
			position: relative;
			line-height: 16px;
			font-size: 16px;
			text-align: center;
			width: 600px;
			margin: auto;
			margin-top: 80px;
			text-indent: 90px;
			.tellanimate{
				position: absolute;
				top: -38px;
				left:60px;
				.animateup{
					margin-left: -10px;
					img{
						width: 55px;
					}
				}
				.animatedown{
					img{
						width:30px;
					}
				}
			}
			a{
				font-style: normal;
				cursor: pointer;
				color: #4257de;
				span{
					color: #d36f2b;
				}
				// &:hover{
				// 	border-bottom:1px solid #4257de;
				// }
			}
		}
		@keyframes fadeUpDown {
			from {
				transform: translateY(0px);
			}
			to {
				transform: translateY(10px);
				// transform: translate3d(0, 100%, 0);
			}
		}
		
		.fadeUpDown {
			animation-name: fadeUpDown;
			animation-duration: 1s;
			animation-iteration-count: infinite;
			animation-direction: alternate;
		}
		h4 {
			width: 100%;
			height: 30px;
			font-size: 30px;
			text-align: center;
			font-weight: normal;
			line-height: 30px;
			color: #333333;
			margin-top: 118px;
		}
		.new-home-titleIcon {
			width: 57px;
			height: 48px;
			background: url(../../assets/images/titleicon.jpg) no-repeat center center;
			background-size: 100% 100%;
			margin: 0 auto;
			margin-top: 17px;
		}
		.new-home-bar {
			width: 962px;
			height: 336px;
			margin: 0 auto;
			margin-top: 90px;
			li {
				width: 218px;
				height: 336px;
				display: block;
				float: left;
				margin-left: 30px;
				div {
					width: 218px;
					height: 275px;
					float: left;
					background-size: 100%;
					position: relative;
					border-radius: 22px;
					box-shadow: 0px 0px 15px #4b91fc;
					cursor: pointer;
					overflow: hidden;
					.img-g {
						width: 100%;
						height: 275px;
						border-radius: 22px;
						background: rgba(0, 0, 0, 0.7);
						font-size: 16px;
						color: #FFFFFF;
						box-sizing: border-box;
						text-align: center;
						line-height: 30px;
						padding-top: 110px;
						display: none;
					}
				}
				.hover {
					transition: all .2s;
					box-shadow: 0px 0px 0px #4b91fc;
				}
				span {
					width: 100%;
					height: 20px;
					display: block;
					float: left;
					font-size: 20px;
					line-height: 20px;
					margin-top: 33px;
					text-align: center;
					color: #333333;
					cursor: default;
				}
			}
			li:first-child {
				margin-left: 0;
			}
			li:first-child div {
				background: url(../../assets/images/new-home-bar1.jpg) no-repeat top center;
				background-size: 218px 275px;
			}
			li:nth-child(2) div {
				background: url(../../assets/images/new-home-bar2.jpg) no-repeat top center;
				background-size: 218px 275px;
			}
			li:nth-child(3) div {
				background: url(../../assets/images/new-home-bar3.jpg) no-repeat top center;
				background-size: 218px 275px;
			}
			li:nth-child(4) div {
				background: url(../../assets/images/new-home-bar4.jpg) no-repeat top center;
				background-size: 218px 275px;
			}
		}
		.new-home-tab {
			width: 931px;
			height: 600px;
			margin: 0 auto;
			margin-top: 80px;
			box-sizing: border-box;
			padding-top: 37.5px;
			background: url(../../assets/images/newhometab.jpg) no-repeat top center;
			background-size: 442px 600px;
			.new-home-tabBox {
				width: 100%;
				height: 525px;
				.new-home-tabImg {
					width: 626px;
					height: 456px;
					float: left;
					margin-top: 35px;
					border-top-right-radius: 180px;
					border-bottom-right-radius: 150px;
					overflow: hidden;
					position: relative;
					div {
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						img {
							width: 327px;
							height: 456px;
						}
						p {
							width: 239px;
							float: right;
							font-size: 18px;
							color: #333333;
							line-height: 50px;
							margin-top: 160px;
						}
					}
				}
				.new-home-btn {
					width: 305px;
					height: 525px;
					float: right;
					li {
						width: 220px;
						height: 77px;
						line-height: 77px;
						font-size: 24px;
						color: #333333;
						display: block;
						float: left;
						background-size: 100%;
						cursor: pointer;
					}
					li:first-child {
						width: 261px;
						text-indent: 50px;
						background: url(../../assets/images/newhometabbtn1.jpg) no-repeat -261px -77px;
						background-size: 261px 77px;
					}
					li:nth-child(2) {
						float: right;
						margin-top: 35px;
						margin-right: 21px;
						text-indent: 65px;
						background: url(../../assets/images/newhometabbtn2.jpg) no-repeat -220px -77px;
						background-size: 220px 77px;
					}
					li:nth-child(3) {
						float: right;
						margin-top: 35px;
						text-indent: 65px;
						background: url(../../assets/images/newhometabbtn2.jpg) no-repeat -220px -77px;
						background-size: 220px 77px;
					}
					li:nth-child(4) {
						float: right;
						margin-top: 35px;
						margin-right: 21px;
						text-indent: 48px;
						background: url(../../assets/images/newhometabbtn2.jpg) no-repeat -220px -77px;
						background-size: 220px 77px;
					}
					li:nth-child(5) {
						margin-top: 35px;
						text-indent: 57px;
						background: url(../../assets/images/newhometabbtn2.jpg) no-repeat -220px -77px;
						background-size: 220px 77px;
					}
					.activeds {
						background-position: center center !important;
						color: #FFFFFF;
					}
				}
			}
		}
		.new-home-list {
			width: 955px;
			height: 370px;
			margin: 0 auto;
			margin-top: 80px;
			.new-home-listBox {
				display: block;
				width: 100%;
				height: 313px;
				display: block;
				float: left;
				margin-top: 57px;
				border-radius: 22px;
				box-shadow: 0px 5px 39.6px 3.4px rgba(0, 10, 189, 0.18);
				li {
					width: calc(955px / 3);
					height: 313px;
					display: block;
					float: left;
					position: relative;
					span {
						position: absolute;
						display: block;
						width: 110px;
						height: 110px;
						border-radius: 50%;
						overflow: hidden;
						background-image: linear-gradient(107deg, #3e1cd1 1%, #0030ff 100%), linear-gradient( #27b5ff, #27b5ff);
						background-blend-mode: normal, normal;
						left: 50%;
						margin-left: -55px;
						top: -55px;
						text-align: center;
						line-height: 111px;
						font-size: 24px;
						font-weight: bold;
						cursor: default;
						color: #FFFFFF;
						box-shadow: -0.8px -4.9px 39.6px 3.4px rgba(0, 10, 189, 0.39);
						animation: breathe 2000ms infinite ease-in-out alternate;
						-webkit-animation: breathe 2000ms infinite ease-in-out alternate;
						-moz-animation: breathe 2000ms infinite ease-in-out alternate;
						-ms-animation: breathe 2000ms infinite ease-in-out alternate;
						-o-animation: breathe 2000ms infinite ease-in-out alternate;
					}
					@keyframes breathe {
						0% {
							opacity: 0.8;
							box-shadow: 0px 0px 0 #092df8;
						}
						100% {
							opacity: 1;
							box-shadow: -0.8px -4.9px 39.6px 3.4px rgba(0, 10, 189, 0.39);
						}
					}
					@-webkit-keyframes breathe {
						0% {
							opacity: 0.8;
							box-shadow: 0px 0px 0 #092df8;
						}
						100% {
							opacity: 1;
							box-shadow: -0.8px -4.9px 39.6px 3.4px rgba(0, 10, 189, 0.39);
						}
					}
					@-moz-keyframes breathe {
						0% {
							opacity: 0.8;
							box-shadow: 0px 0px 0 #092df8;
						}
						100% {
							opacity: 1;
							box-shadow: -0.8px -4.9px 39.6px 3.4px rgba(0, 10, 189, 0.39);
						}
					}
					@-ms-keyframes breathe {
						0% {
							opacity: 0.8;
							box-shadow: 0px 0px 0 #092df8;
						}
						100% {
							opacity: 1;
							box-shadow: -0.8px -4.9px 39.6px 3.4px rgba(0, 10, 189, 0.39);
						}
					}
					@-o-keyframes breathe {
						0% {
							opacity: 0.8;
							box-shadow: 0px 0px 0 #092df8;
						}
						100% {
							opacity: 1;
							box-shadow: -0.8px -4.9px 39.6px 3.4px rgba(0, 10, 189, 0.39);
						}
					}
					p {
						width: 100%;
						height: 18px;
						color: #333333;
						text-align: center;
						font-size: 18px;
						line-height: 18px;
					}
					p:first-child {
						margin-top: 115px;
					}
					i {
						display: block;
						width: 18px;
						height: 4px;
						background: #82cbff;
						margin: 20px auto;
					}
				}
			}
		}
		.new-home-letunion {
			width: 100%;
			height: 30px;
			font-size: 30px;
			line-height: 30px;
			color: #333333;
			text-align: center;
			margin-top: 144px;
		}
		.new-home-letunionIcon {
			width: 77px;
			height: 8px;
			margin: 0 auto;
			margin-top: 30px;
			background-image: linear-gradient(107deg, #3e1cd1 1%, #0030ff 100%), linear-gradient( #00a0e9, #00a0e9);
			background-blend-mode: normal, normal;
			border-radius: 3.4px;
		}
		.new-home-letBth {
			width: 576px;
			height: 52px;
			margin: 0 auto;
			margin-top: 80px;
			margin-bottom: 120px;
			a {
				display: block;
				width: 214px;
				height: 52px;
				float: left;
				text-align: center;
				line-height: 52px;
				color: #FFFFFF;
				font-size: 24px;
				border-radius: 26px;
			}
			a:first-child {
				background-image: linear-gradient(145deg, #fe8f19 0%, #fe2c45 100%), linear-gradient( #ffffff, #ffffff);
				background-blend-mode: normal, normal;
				box-shadow: 0px 0px 0px 0px #FFFFFF;
			}
			a:nth-child(2) {
				background-image: linear-gradient(-80deg, #3e1cd1 0%, #07d5ff 100%);
				box-shadow: 0px 0px 0px 0px #FFFFFF;
				float: right;
			}
			.flows:hover {
				transition: all 0.5s;
				box-shadow: 0px 1px 19px 1px rgba(227, 0, 10, 0.39);
			}
			.news:hover {
				transition: all 0.5s;
				box-shadow: 0px 1px 19px 1px rgba(4, 16, 209, 0.39);
			}
		}
	}

	.new-home-partner {
		width: 1128px;
		height: 312px;
		margin: 0 auto;
		margin-top: 90px;
		position: relative;
		li {
			width: 100%;
			height: auto;
			display: flex;
			align-items: center;
		}
		li:last-child {
			position: absolute;
			bottom: 0;
		}
		li:nth-child(2) {
			position: absolute;
			top: 50%;
			margin-top: -25px;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	.fadeIn {
		animation-duration: 1s;
		animation-fill-mode: both;
		animation-name: fadeIn;
	}

	@keyframes fadeOut {
		from {
			opacity: 0;
		}
		to {
			opacity: 0;
		}
	}

	.fadeOut {
		animation-duration: 1s;
		animation-fill-mode: both;
		animation-name: fadeOut;
	}

	@media (min-width: 1300px) {
		.new-home-page {
			.swiper{
				position: relative;
				height: 1051px;
				overflow:hidden;
				@keyframes fadeInRight {
					from {
						opacity: 0;
						transform: translate3d(100%, 0, 0);
					}
					to {
						opacity: 1;
						transform: none;
					}
				}
				
				.fadeInRight {
					animation-name: fadeInRight;
					animation-duration: 1s;
					animation-fill-mode: both;
				}
				
				@keyframes fadeOutLeft {
					from {
						opacity: 1;
					}
					to {
						opacity: 0;
						transform: translate3d(-100%, 0, 0);
					}
				}
				
				.fadeOutLeft {
					animation-name: fadeOutLeft;
					animation-duration: 1s;
					animation-fill-mode: both;
				}
			.new-home-box {
				box-sizing: border-box;
				width: 100%;
				height: 1051px;
				margin: 0 auto;
				&.img1{
					background: url(../../assets/images/newhomebgb.jpg) no-repeat top center;
					background-size: cover;
				}
				&.img2{
					background: url(../../assets/images/newhomebgb1.jpg) no-repeat top center;
					background-size: cover;
				}
				nav {
					width: 1200px;
					height: 44px;
					margin: 0 auto;
					.nav-logo {
						width: 188px;
						height: 38px;
						border-right: 2px solid #b0a2ec;
						display: flex;
						justify-content: center;
						align-items: center;
						float: left;
						margin-top: 3px;
						img {
							width: 151px;
							height: 37px;
						}
					}
					.nav-title {
						width: auto;
						height: 44px;
						float: left;
						margin-left: 20px;
						span {
							height: 12px;
							line-height: 12px;
							display: block;
							color: #FFFFFF;
							font-size: 12px;
						}
						span:first-child {
							margin-top: 8px;
						}
						span:nth-child(2) {
							margin-top: 7px;
						}
					}
				}
			}
			}
		}
	}
</style>
<template>
	<div class="new-home-page">
		<Newnav/>
		<div class="swiper">
		<transition-group mode="in-out" tag="div" enter-active-class="fadeInRight" leave-active-class="fadeOutLeft">
		<div class="new-home-box" :class="item.img" v-for="(item,index) in headImg" :key="index" v-show="index == headnum">
			<div class="title" :class="item.tit">
			<p class="banner-title">{{item.p1}}</p>
			<p class="banner-title2">{{item.p2}}</p>
			<p class="banner-title3">{{item.p3}}</p>
			</div>
		</div>
		</transition-group>
		</div>
		<div class="tellall">
			<div class="tellanimate">
				<div class="animateup fadeUpDown">
					<img src="../../assets/images/telliconup.png" alt="">
				</div>
				<div class="animatedown">
					<img src="../../assets/images/tellicondown.png" alt="">
				</div>
			</div>
			<!-- /sdkdoc/kyysdkup -->
			<a href="javascript:;" style="text-decoration:none !important;">玩咖优盟品牌正式升级为万咖智星</a>
		</div>
		<div class="new-home-title">“万咖智星”是玩咖欢聚推出的专业化移动广告平台。平台基于人工智能及数据分析能力构建核心，</div>
		<div class="new-home-title" style="margin-top: 30px;">专注于为流量主提供变现及移动分析解决方案。</div>
		<h4>我们的优势</h4>
		<div class="new-home-titleIcon"></div>
		<div class="new-home-title" style="margin-top: 60px;">万咖智星依托大数据精准的人群分析能力和海量的优质广告素材，通过丰富的广告样式为广大流量主提供</div>
		<div class="new-home-title" style="margin-top: 30px;">最优质的商业化解决方案，最大限度提高广告填充率和eCPM。</div>
		<ul class="new-home-bar">
			<li>
				<div class="img-box">
					<p class="img-g">支持多种售卖方式</br>确保变现潜力被挖掘</p>
				</div>
				<span>高额的变现收益</span>
			</li>
			<li>
				<div class="img-box">
					<p class="img-g">覆盖互动广告&nbsp;&nbsp;信息流广告</br>分发广告等多种广告样式</p>
				</div>
				<span>多样的广告形式</span>
			</li>
			<li>
				<div class="img-box">
					<p class="img-g">海量广告主以及精准匹配</br>保证极高展示率以及填充率</p>
				</div>
				<span>丰富的广告资源</span>
			</li>
			<li>
				<div class="img-box">
					<p class="img-g">支持SDK&nbsp;&nbsp;API及URL集成</br>轻松&nbsp;&nbsp;快速&nbsp;&nbsp;简单</p>
				</div>
				<span>灵活的集成方式</span>
			</li>
		</ul>
		<h4 style="margin-top: 110px;">广告样式</h4>
		<div class="new-home-titleIcon"></div>
		<div class="new-home-title" style="margin-top: 60px;">万咖智星不仅覆盖当前主流广告样式，还在样式创新的道路上走在行业前沿</div>
		<div class="new-home-tab">
			<div class="new-home-tabBox">
				<transition-group mode="in-out" name="fade" tag="div" class="new-home-tabImg">
					<div v-for="(item,index) in tabcon" :key="index" v-show="index == num">
						<img v-bind:src="item.tabimgs" />
						<p>{{item.tabtitle}}</p>
					</div>
				</transition-group>
				<ul class="new-home-btn">
					<li v-for="(item,index) in tabs" :key="index" :class="{activeds:index == num}" @mouseover="overShow(index)" @mouseout="overHide(index)">{{item}}</li>
				</ul>
			</div>
		</div>
		<h4>轻松集成</h4>
		<div class="new-home-title" style="margin-top: 42px;">广告变现之旅 从接入万咖智星开始</div>
		<div class="new-home-list">
			<ul class="new-home-listBox">
				<li>
					<p>稳定 轻量 兼容</p>
					<i></i>
					<p>少延迟 高eCPM</p>
					<i></i>
					<p>安全广告质量控制</p>
					<span>S D K</span>
				</li>
				<li>
					<p>开发成本底</p>
					<i></i>
					<p>对接相对简单</p>
					<i></i>
					<p>快速验证用户体验</p>
					<span>A P I</span>
				</li>
				<li>
					<p>互动广告独有</p>
					<i></i>
					<p>无需对接</p>
					<i></i>
					<p>即嵌即用</p>
					<span>U R L</span>
				</li>
			</ul>
		</div>
		<h4 style="margin-top: 160px;">合作伙伴</h4>
		<div class="new-home-titleIcon"></div>
		<ul class="new-home-partner">
			<li>
				<img src="../../assets/images/partner1.png" width="112" height="18" style="margin-left: 9px;" />
				<img src="../../assets/images/partner2.png" width="81" height="24" style="margin-left: 101px;" />
				<img src="../../assets/images/partner3.png" width="104" height="19" style="margin-left: 109px;" />
				<img src="../../assets/images/partner4.png" width="123" height="26" style="margin-left: 85px;" />
				<img src="../../assets/images/partner5.png" width="106" height="21" style="margin-left: 84px;" />
				<img src="../../assets/images/partner6.png" width="131" height="18" style="margin-left: 81px;" />
			</li>
			<li>
				<img src="../../assets/images/partner7.png" width="132" height="41" />
				<img src="../../assets/images/partner8.png" width="116" height="33" style="margin-left: 74px;" />
				<img src="../../assets/images/partner9.png" width="123" height="50" style="margin-left: 80px;" />
				<img src="../../assets/images/partner10.png" width="99" height="33" style="margin-left: 88px;" />
				<img src="../../assets/images/partner11.png" width="113" height="44" style="margin-left: 93px;" />
				<img src="../../assets/images/partner12.png" width="124" height="32" style="margin-left: 81px;" />
			</li>
			<li>
				<img src="../../assets/images/partner13.png" width="112" height="34" style="margin-left: 15px;" />
				<img src="../../assets/images/partner14.png" width="116" height="21" style="margin-left: 79px;" />
				<img src="../../assets/images/partner15.png" width="89" height="23" style="margin-left: 101px;" />
				<img src="../../assets/images/partner16.png" width="177" height="22" style="margin-left: 68px;" />
				<img src="../../assets/images/partner17.png" width="110" height="23" style="margin-left: 63px;" />
				<img src="../../assets/images/partner18.png" width="115" height="17" style="margin-left: 83px;" />
			</li>
		</ul>
		<div class="new-home-letunion">和万咖智星一起发展你的移动事业吧</div>
		<div class="new-home-letunionIcon"></div>
		<div class="new-home-letBth">
			<router-link to="/publish" class="flows">流量主</router-link>
			<router-link to="/advertiser" class="news">广告主</router-link>
		</div>
		<Newfooter/>
	</div>

</template>
<script>
	import Newnav from './common/Newnav.vue';
	import Newfooter from './common/Newfooter.vue';
	import tabimgs1 from '../../assets/images/newhometabimg1.jpg';
	import tabimgs2 from '../../assets/images/newhometabimg2.jpg';
	import tabimgs3 from '../../assets/images/newhometabimg3.jpg';
	import tabimgs4 from '../../assets/images/newhometabimg4.jpg';
	import tabimgs5 from '../../assets/images/newhometabimg5.jpg';
	export default {
		components: {
			Newnav,
			Newfooter
		},
		props: {},
		data() {
			return {
				num: 0,
				_timeOut: '',
				headnum: 0,
				_timeHeadOut: '',
				headImg: [
					{
						tit:"title2",
						img:"img2",
						p1:"SECURITY·QUICK ·STABLE",
						p2:"快应用广告SDK",
						p3:"正式发布",
					},
					{
						tit:"title1",
						img:"img1",
						p1:"优质结盟 合作共赢",
						p2:"移动广告平台",
						p3:"为流量主提供变现及移动分析解决方案",
					}
					],
				tabs: ["原生信息流广告", "互动广告", "分发广告", "标准展示广告", "快应用广告"],
				tabimgs: [tabimgs1, tabimgs2, tabimgs3, tabimgs4, tabimgs5],
				tabcon: [{
						tabtitle: "与媒体的设计布局无缝衔接，向用户传递与媒体内容完美融合的广告体验。",
						tabimgs: tabimgs1
					},
					{
						tabtitle: "多样化的互动落地页模版，以游戏互动的方式活跃用户。",
						tabimgs: tabimgs2
					},
					{
						tabtitle: "以应用商店与搜索等分发入口为主的场景，服务移动App下载资源流量。",
						tabimgs: tabimgs3
					},
					{
						tabtitle: "横幅广告，插屏广告，开屏广告。适用于每一个移动设备、平台和广告投放目的。",
						tabimgs: tabimgs4
					},
					{
						tabtitle: "汇聚高质量快应用广告资源。支持主流广告形式：横幅、插屏、浮层、原生等。",
						tabimgs: tabimgs5
					}
				]

			};
		},
		methods: {
			//头部导航移入移出效果
			changeActive($event) {
				$event.currentTarget.className = "actived";
			},
			removeActive($event) {
				$event.currentTarget.className = "";
			},

			overShow: function(index) {
				this.num = index;
				clearInterval(this._timeOut);
			},
			overHide: function(index) {
				this._timeOut = setInterval(this.cartView, 3000)
			},
			cartView: function() {
				let setnum = 0;
				if(this.num <= 3) {
					this.num++;
				} else {
					this.num = 0;
				}
			},
			cartHeadView: function() {
				let setnum = 0;
				if(this.headnum < this.headImg.length - 1) {
					this.headnum++;
				} else {
					this.headnum = 0;
				}
			},
			// kyypush() {
			// 	let routeData = this.$router.resolve({
			// 	name: "kyysdkup",
			// 	})
			// 	window.open(routeData.href, '_blank')
			// }
		},
		created() {

		},
		mounted() { //我们的优势鼠标移入效果
			$('.img-box').hover(function() {
				$(this).children('.img-g').stop().fadeToggle(200);
				$(this).toggleClass('hover')
			});

			//我们的优势轮播图
			this.$nextTick(() => {
				this._timeOut = setInterval(this.cartView, 3000);
			});
			//header轮播图
			this._timeHeadOut = setInterval(this.cartHeadView, 7400);

		}
	};
</script>



// WEBPACK FOOTER //
// src/pages/NewHome/newHome.vue